<template>
  <div class="intercomdescribe">
    <div class="header">
      <div class="title">楼宇对讲智能硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in monitoringdescriptionList"
          :key="item.id"
        >
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import intercomdescribe1 from "../../../../assets/programme/intercomdescribe1.png";
import intercomdescribe2 from "../../../../assets/programme/intercomdescribe2.png";
import intercomdescribe3 from "../../../../assets/programme/intercomdescribe3.png";
import intercomdescribe4 from "../../../../assets/programme/intercomdescribe4.png";
import intercomdescribe5 from "../../../../assets/programme/intercomdescribe5.png";
import intercomdescribe6 from "../../../../assets/programme/intercomdescribe6.png";

export default {
  setup() {
    return reactive({
      monitoringdescriptionList: [
        {
          id: 1,
          title: "液晶屏室内对讲分机",
          logo: intercomdescribe1,
        },
        {
          id: 2,
          title: "液晶彩色对讲分机",
          logo: intercomdescribe2,
        },
        {
          id: 3,
          title: "对讲管理主机",
          logo: intercomdescribe3,
        },
        {
          id: 4,
          title: "非可视直按键式对讲主机",
          logo: intercomdescribe4,
        },
        {
          id: 5,
          title: "可视对讲主机",
          logo: intercomdescribe5,
        },
        {
          id: 6,
          title: "刷卡防水色彩主机",
          logo: intercomdescribe6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.intercomdescribe {
  width: 1180px;
  margin: 0 auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  justify-content: space-between;
}
.body .list .item {
  text-align: center;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 180px;
}
.body .list .item div {
  margin-top: 30px;
}
</style>
